import { groupBy } from "lodash";
import { DraxRole } from "store/slice/Team";

export const groupRolesByFunction = (rolesData: DraxRole[]) => {
    const groupedByFunctions = groupBy(rolesData, "function");
    const functionsList = Object.entries(groupedByFunctions).map((element, index) => ({
        id: index,
        function: element[0],
        ids: element[1].map((element) => element.id),
        key: index,
        value: element[0],
        selected: false,
    }));
    return functionsList;
};
